module.exports.default = {
    "ORDER": "Eskaera",
    "SCHEDULE.YOU_ARE_ALL_SET": "",
    "SCHEDULE.YOUR_DELIVERY_IS_SCHEDULED_FOR": "Zure entrega ondorengo datan programatuta dago:",
    "SCHEDULE.CUSTOMER_#_MESSAGE": "Kaixo #, mesedez, programatu zure entrega",
    "SCHEDULE.SCHEDULE_NOW": "Berriz programatu",
    "SCHEDULE.DELIVERY_STATUS_UPDATES": "Entrega eta Egoeren Eguneraketa",
    "SCHEDULE.EMAIL_UPDATES": "Posta elektroniko bidezko eguneraketak",
    "SCHEDULE.SMS_UPDATES": "SMS bidezko eguneraketak",
    "SCHEDULE.DISABLE_UPDATES": "Ez dut eguneraketarik jaso nahi",
    "SCHEDULE.STATUS_UPDATE_IN_THE_FOLLOWING": "Nire entregaren egoeraren eguneraketak jaso nahi ditut, ondorengo kanalen bitartez:",
    "OOPS": "Ene!",
    "SOMETHING_WENT_WRONG": "Arazo bat gertatu da.",
    "REFRESH": "Eguneratu",
    "PAGE_NOT_FOUND": "Ez da orrialdea aurkitu",
    "COULD_NOT_FIND_PAGE": "Ez dugu aurkitu bilatzen zenuen orrialdea.",
    "TRACKING.MESSAGE_DRIVER_FAILED": "Ezin duzu hutsik dagoen mezurik bidali",
    "TRACKING.MESSAGE_DRIVER_PLACEHOLDER": "Mesedez, idatzi banatzailearentzako mezua",
    "TRACKING.SEND": "Bidali",
    "TRACKING.ARRIVING_AT": "Ordu honetan iritsiko da:",
    "TRACKING.ETA": "ETA",
    "TRACKING.MIN": "minutu",
    "TRACKING.MAP": "Mapa",
    "TRACKING.SATELLITE": "Satelitea",
    "TRACKING.TERRAIN": "Erliebea",
    "TRACKING.DRIVER_ARRIVED_MESSAGE": "Kaixo. Iritsi naiz!",
    "TRACKING.DRIVER_ARRIVED_AT_MESSAGE": ",zure banatzailea, iritsi da hona:",
    "COMPLETED": "Eginda",
    "RATING.SKIP": "Orain ez",
    "RATING.WHAT_WENT_WELL": "Zer atera da ondo?",
    "RATING.WHAT_WENT_WRONG": "Zer atera da txarto?",
    "RATING.THANK_YOU": "Eskerrik asko",
    "RATING.FOR_USING_OUR_SERVICE": "Asko gure zerbitzua erabiltzeagatik",
    "RATING.HOW_WAS_YOUR_DELIVERY": "Nolakoa izan da zure eskaera jasotzeko esperientzia?",
    "RATING.WHAT_WAS_YOUR_EXPERIENCE": "Asko gure zerbitzua erabiltzeagatik",
    "SCHEDULE.RATE_US": "Balora iezaguzu",
    "TERM_OF_USE": "Erabilera-baldintzak",
    "PRIVACY_POLICY": "Pribatutasun-politika",
    "SHARING_MY_LOCATION": "Nire kokapena partekatzen",
    "SHARING_LOADING": "Kargatzen",
    "REQUIRED_FIELD_MESSAGE": "Eremu hau derrigorrez bete behar da",
    "CONTACT_NAME": "Kontaktu-izena",
    "PHONE_NUMBER": "Telefono-zenbakia",
    "EMAIL_ADDRESS": "Helbide elektronikoa",
    "SEND": "Bidali",
    "FORWARD.THIS_ORDER": "Bidali eskaera hau",
    "FORWARD.TO_CONTACT": "Bidali kontaktu honi",
    "FORWARD.ARE_YOU_SURE_MESSAGE": "Ziur zaude eskaera hau bidali nahi duzula?",
    "FORWARDED.HAS_DELIVERY_FORWARDED_DELIVERY": "eskaera bat bidali dizu",
    "FORWARDED.ARE_YOU_SURE_MESSAGE": "Ziur zaude eskaera hau bertan behera utzi nahi duzula?",
    "ACCEPT": "Onartu",
    "REJECT": "Uko egin",
    "PICKUP.SET_PICKUP_TIME": "",
    "PICKUP.IVE_ARRIVED": "",
    "PICKUP.PICKUP_ETA_SET_FAILED": "",
    "PICKUP.ETA_SET_FAILED_DESCRIPTION": "",
    "PICKUP.MIN": "minutu",
    "PICKUP.SHOW_THIS_NUMBER": "",
    "PICKUP.IM_OUTSIDE": "",
    "PICKUP.LET_THEM_KNOW_YOUR_OUTSIDE?": "",
    "PICKUP.I_WILL_ARRIVE_AT": "",
    "PICKUP.PICKUP_ETA_SUCCESSFULLY_SET": "",
    "PICKUP.IN": "",
    "PICKUP.TO": "",
    "PICKUP.COLLECT": "",
    "PICKUP.SELECT_METHOD_OF_TRANSPORT": "",
    "PICKUP.CONFIRM_METHOD_OF_TRANSPORT": "",
    "PICKUP.CANCEL": "",
    "PICKUP.CONFIRM_TIME": "",
    "TRACKING.DRIVER_ROUTE_ONE_STOP_MESSAGE": "",
    "TRACKING.DRIVER_ROUTE_STOPS_MESSAGE_PART2": "",
    "TRACKING.DRIVER_ROUTE_STOPS_MESSAGE_PART1": "",
    "PICKUP.OK": "",
    "PICKUP.NEXT": "",
    "PICKUP.SKIP": "Saltatu",
    "CAR_ARRIVED.TITLE": "",
    "CAR_ARRIVED.PARKING_SPOT": "",
    "CAR_ARRIVED.LICENSE_PLATE": "",
    "CAR_ARRIVED.VEHICLE_MODEL": "",
    "CAR_ARRIVED.VEHICLE_COLOR": "",
    "CAR_ARRIVED.REMEMBER": "",
    "CAR_ARRIVED.PARKING_SPOT_EXAMPLE": "",
    "CAR_ARRIVED.LICENSE_PLATE_EXAMPLE": "",
    "CAR_ARRIVED.VEHICLE_MODEL_EXAMPLE": "",
    "CAR_ARRIVED.VEHICLE_COLOR_EXAMPLE": "",
    "REDIRECT_PICKUP.TO": "",
    "REDIRECT_PICKUP.CONFIRM_TITLE": "",
    "REDIRECT_PICKUP.SUCCESS_TITLE": "",
    "REDIRECT_PICKUP.FAILED_TITLE": "",
    "REDIRECT_PICKUP.FAILED_DESCRIPTION": "",
    "REDIRECT_PICKUP.OK": "",
    "REDIRECT_PICKUP.KM": "",
    "REDIRECT_PICKUP.SELECT_PICKUP_LOCATION": "",
    "REDIRECT_PICKUP.SET_AS_PICKUP_LOCATION": "",
    "REDIRECT_PICKUP.PICKUP_OPTIONS": "",
    "SOON": "",
    "TRACKING.WANT_TO_CALL_YOUR_DRIVER": "",
    "GLOBAL.CALL": "",
    "GLOBAL.CANCEL": "",
    "﻿PICKUP.SET_PICKUP_TIME": "",
    "RATING.PROOF_OF_DELIVERY_MESSAGE": "",
    "SCHEDULED.THANKS_FOR_USING": "",
    "SCHEDULED.SHIPMENT_IN_TRANSIT": "",
    "SCHEDULED.YOUR_DELIVERY_IS_SCHEDULED_FOR": "Zure entrega ondorengo datan programatuta dago:",
    "Submit": "",
    "RATING.SELECT_STARS_BEFORE_SUBMIT": "Balioetsi ahal izateko, hautatu izarrak lehenbizi",
    "PICKUP.SHOW_ID": "",
    "TRACKING.ESTIMATED_TIME_ARRIVAL": "",
    "OPEN_MENU": "",
    "CLOSE_MENU": "",
    "MAP_AUTO_CENTER": "",
    "MAP_SETTINGS": "",
    "ZOOM_OUT": "",
    "ZOOM_IN": "",
    "TRACKING.CALL_DRIVER": "",
    "TRACKING.MESSAGE_DRIVER": "",
    "PICKUP.SELECT_TIME_TO_CONFIRM": "",
    "PICKUP.SET_OR_ARRIVE_DESCRIPTION": "",
    "SCHEDULE.TIME_ZONE_TEXT": "",
    "TRACKING.THANKS_MESSAGE_SUBTITLE": "",
    "TRACKING.THANKS_MESSAGE_TEXT": "",
    "TRACKING.THANKS_MESSAGE_TITLE": "",
    "TRACKING.CLICK_COLLECT_MESSAGE_TEXT": "",
    "CANCEL_ORDER": "",
    "CANCELLATION_VALIDATION_TITLE": "",
    "CANCELLATION_VALIDATION_BACK": "",
    "CANCELLATION_VALIDATION_YES": "",
    "CANCEL_SUCCESS": "",
    "CANCEL_PAST_ALLOWED": "",
    "CANCEL_ERROR": "",
    "RATING.FREE_TEXT_COMMENT": "",
    "RATING.ORDER_DELIVERED_GREEN": "",
    "CX_ORDER_STATUS.CONFIRMED": "",
    "CX_ORDER_STATUS.RECEIVED": "",
    "CX_ORDER_STATUS.FINDING_DRIVER": "",
    "CX_ORDER_STATUS.DRIVER_FOUND": "",
    "CX_ORDER_STATUS.PICKING_UP": "",
    "CX_ORDER_STATUS.WAY_TO_PICKUP": "",
    "CX_ORDER_STATUS.ON_PREVIOUS_DELIVERY": "",
    "CX_ORDER_STATUS.WAY_TO_DROPOFF": "",
    "CX_ORDER_STATUS.ARRIVED": "",
    "TRACKING.DELIVERY_STATUS_TITLE": "",
    "CONFIGURATION.TAGS.SHOW_DELIVERY_STATUS": "",
    "CONFIRM": "",
    "FLOW_OPTIONS.TITLE": "",
    "FLOW_OPTIONS.CURBSIDE_BUTTON_LABEL": "",
    "FLOW_OPTIONS.CURBSIDE_BUTTON_TEXT": "",
    "FLOW_OPTIONS.CLICK_AND_COLLECT_LABEL": "",
    "FLOW_OPTIONS.CLICK_AND_COLLECT_TEXT": "",
    "RATING_STAR_ALT": "",
    "RATING_STAR_ALT_ONE": "",
    "RATING_STAR_ALT_TWO": "",
    "TRACKING.ARRIVING_IN_ARIA_LABEL": "",
    "TRACKING.MAP_CONTAINER_ARIA_LABEL": "",
    "SCHEDULE.EXTERNAL_ID_INFO": "",
    "SCHEDULE.TASK_NOTE_LABEL": "",
    "SCHEDULE.CANCEL_NOTE_INPUT": "",
    "DELIVERY_WAS_CANCELLED": "",
    "QUESTIONNAIRE.SKIP": "",
    "QUESTIONNAIRE.SKIP_VALIDATION_HEADER": "",
    "QUESTIONNAIRE.SKIP_VALIDATION_MESSAGE": "",
    "QUESTIONNAIRE.BACK": "",
    "QUESTIONNAIRE.SUBMIT_FAILED": "",
    "QUESTIONNAIRE.SUBMIT_SUCCESS": "",
    "QUESTIONNAIRE.NA_VALUE": "",
    "QUESTIONNAIRE.SUBMIT_SUCCESS_TITLE": "",
    "QUESTIONNAIRE.SUBMIT_SUCCESS_MESSAGE": "",
    "QUESTIONNAIRE.PROGRESS_BAR_TITLE": "",
    "QUESTIONNAIRE.NEXT": "",
    "QUESTIONNAIRE.INVALID_FORMAT": "",
    "RESCHEDULE.NEED_A_DIFFERENT_TIME": "",
    "RESCHEDULE.RESCHEDULE_YOUR_DELIVERY": "",
    "RESCHEDULE.GREETING": "",
    "RESCHEDULE.FIRST_AVAILABLE": "",
    "RESCHEDULE.SAME_DAY": "",
    "RESCHEDULE.PICK_A_DATE": "",
    "RESCHEDULE.NEAREST_WINDOWS": "",
    "RESCHEDULE.WINDOWS_FOR_DATE": "",
    "RESCHEDULE.WHICH_DATE": "",
    "RESCHEDULE.NO_WINDOWS": "",
    "RESCHEDULE.NO_WINDOWS_AVAILABLE": "",
    "RESCHEDULE.SOMETHING_WENT_WRONG": "",
    "RESCHEDULE.TRY_AGAIN": "",
    "RESCHEDULE.BACK_TO_START": "",
    "RESCHEDULE.BACK_TO_DELIVERY": "",
    "RESCHEDULE.CONFIRMED": "",
    "RESCHEDULE.TYPE_A_MESSAGE": "",
    "RESCHEDULE.TODAY": ""
};
	